/**
 * The order statuses, in the order an order moves through them. `code` is what
 * the API's `status` filter takes; `status` is the text the API returns for it
 * (what the badge and label helpers are keyed by).
 *
 * @typedef {"OP"|"SE"|"CO"|"DO"|"PA"|"CA"|"EX"} OrderStatusCode
 */
/** @type {{code: OrderStatusCode, status: string, final: boolean}[]} */
export const ORDER_STATUSES = [
    {code: "OP", status: "Open", final: false},
    {code: "SE", status: "Sent", final: false},
    {code: "CO", status: "Confirmed", final: false},
    {code: "DO", status: "Done", final: false},
    {code: "PA", status: "Paid", final: true},
    {code: "CA", status: "Canceled", final: true},
    {code: "EX", status: "Expired", final: true},
];

/** What the orders list shows to begin with: orders that are still going. */
export const DEFAULT_STATUS_FILTER = ORDER_STATUSES.filter((s) => !s.final).map((s) => s.code);

// The order API returns the (English) display text of the status.
const ORDER_STATUS_LABELS = {
    Open: "Aberta",
    Sent: "Enviada",
    Confirmed: "Confirmada",
    Expired: "Expirada",
    Canceled: "Cancelada",
    Done: "Concluída",
    Paid: "Paga",
};

/** @param {string} status */
export const orderStatusLabel = (status) => ORDER_STATUS_LABELS[status] ?? status;
